import { render, staticRenderFns } from "./Idi.html?vue&type=template&id=ed1e2980&scoped=true&"
import script from "./Idi.vue?vue&type=script&lang=js&"
export * from "./Idi.vue?vue&type=script&lang=js&"
import style0 from "./Idi.scss?vue&type=style&index=0&id=ed1e2980&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1e2980",
  null
  
)

export default component.exports